import { c as _c } from "react/compiler-runtime";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { Loading } from "@website/ui/loading";
import { getOrigin } from "@website/utils/channel/get-origin";
import { Banner, BannerPropertiesType } from "@website/widget/banner";
import { GetServerSideProps } from "next";
const Index = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["flight_takeoff_external_widget"],
      queryFn: _temp3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: data_0,
    isLoading
  } = useFetcher(t0);
  if (isLoading) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex w-screen justify-center py-2"><Loading /></div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (!data_0?.items?.length) {
    return null;
  }
  let t1;
  if ($[2] !== data_0) {
    t1 = <Banner {...data_0} />;
    $[2] = data_0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default Index;
export const getServerSideProps: GetServerSideProps = async () => ({
  props: {}
});
function _temp(item) {
  return {
    icon: "flight",
    title: item.title,
    price: item.price / 10,
    currency: "\u062A\u0648\u0645\u0627\u0646",
    link: item.url
  };
}
function _temp2(data) {
  return {
    icon: "flight_takeoff",
    title: "\u062E\u0631\u06CC\u062F \u0628\u0644\u06CC\u0637 \u067E\u0631\u0648\u0627\u0632 \u062E\u0627\u0631\u062C\u06CC",
    link: `${getOrigin()}/inter-flights`,
    items: Array.isArray(data?.data) ? data.data.map(_temp) : []
  };
}
function _temp3() {
  return fetcher({
    url: `${process.env.NEXT_PUBLIC_BASE_URL_API}/api/price-table/external-widget`,
    method: "GET"
  }).then(_temp2);
}